import { useEffect, useMemo, useState } from 'preact/hooks'

const colourKeys = ['Colours', 'Colors', 'Chocolate', 'Choose chocolate type']

function ProductVariant({ variants, initVariant, options, updateCurrentVariant, className = 'flex flex-col pb-4 text-sm', updateUrl = true }) {
  const [selected, setSelected] = useState({})

  const getSelectedVariant = (selectedValues) => {
    const matched = variants.filter((variant) => {
      const matchedOptions = []
      for (const option in selectedValues) {
        matchedOptions.push(variant.options.includes(selectedValues[option]))
      }
      return matchedOptions.reduce((result, item) => result && item, [])
    })

    return matched[0]
  }

  const getInitialSelected = (currentVariant) => {
    const values = {}
    for (const index in options) {
      const option = options[index]

      if (!values[option]) {
        values[option] = []
      }

      const value = currentVariant.options[index]
      if (!values[option].includes(value)) {
        values[option] = value
      }
    }

    return values
  }

  const setUrlParams = (variant) => {
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.has('variant')) {
      urlParams.append('variant', variant.id)
    } else {
      urlParams.set('variant', variant.id)
    }
    window.history.replaceState({}, null, `${window.location.pathname}?${urlParams.toString()}`)
  }

  useEffect(() => {
    const selectedInit = getInitialSelected(initVariant)
    setSelected(selectedInit)
  }, [])

  const availableValues = (() => {
    const values = {}
    for (const index in options) {
      const option = options[index]

      if (!values[option]) {
        values[option] = []
      }

      for (const variant of variants) {
        const value = variant.options[index]
        if (!values[option].includes(value)) {
          values[option].push(value)
        }
      }
    }
    return values
  })()

  const isOnlyVariantDefault = useMemo(() => {
    return variants.length === 1 && variants[0].title === 'Default Title'
  }, [])

  useEffect(() => {
    const selectedVariant = getSelectedVariant(selected)
    if (selectedVariant) {
      updateCurrentVariant(selectedVariant)
      if (updateUrl) {
        setUrlParams(selectedVariant)
      }
    }
  }, [selected])

  return (
    <div className={className}>
      {!isOnlyVariantDefault &&
        Object.entries(availableValues).map(([key, values], index) => (
          <VariantGroup key={index} name={key} values={values} selected={selected} setSelected={setSelected} />
        ))}
    </div>
  )
}

function VariantGroup({ name, values, selected, setSelected }) {
  return (
    <div className={`mt-5 ${colourKeys.includes(name) ? 'order-first' : ''}`}>
      <VariantDropdown items={values} option={name} selected={selected} setSelected={setSelected} />
    </div>
  )
}

function VariantDropdown({ items, option, selected, setSelected }) {
  const onChange = (e) => {
    selected = { ...selected, [option]: e.target.value }
    setSelected(selected)
  }

  return (
    items.length && (
      <select onChange={onChange} className="input !pt-3.5 !pb-2.5">
        {items.map((item) => (
          <option value={item} selected={selected[option] === item}>
            {item}
          </option>
        ))}
      </select>
    )
  )
}

export default ProductVariant
